<template>
  <div id="app"
       ref="application"
       class="App"
  >
    <router-view />
  </div>
</template>
<script>

export default {
  name: 'App',

  data() {
      return {
        isShow: true,
      };
    },
}
</script>
<style lang="sass" scoped>
.App
  height: 100%
  overflow-y: hidden
  width: 100%
</style>
